var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "GeneralSettings",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c(
            "DIV",
            { staticClass: "h-100 overflow-auto px-3" },
            [
              _c(
                "DIV",
                { staticClass: "card my-3" },
                [
                  _c(
                    "DIV",
                    { staticClass: "card-body" },
                    [
                      _c("H5", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("pgettext")("Email settings", "Settings")
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("P", { staticClass: "card-text" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("gettext")(
                                "Send a test email to the current user's email address."
                              )
                            ) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "ItpBox",
                        { attrs: { direction: "column", alignItems: "start" } },
                        [
                          _c("ItpButton", {
                            attrs: {
                              text: _vm._f("pgettext")(
                                "Send test email",
                                "Tasks|Command"
                              ),
                              icon: "mdi:cog",
                              spinning: _vm.actions.sendmail.isRunning
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return _vm.evh_1269646916756998_clickPreventStop(
                                  $event,
                                  {}
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "ItpAlert",
                            {
                              staticClass: "mt-3",
                              attrs: {
                                type: "success",
                                show: _vm.sendmailResult === true,
                                dismissible: ""
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm._f("pgettext")(
                                        "Email has been successfully sent.",
                                        "Settings"
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }